import { useState, useEffect } from "react";
// CSS imports commented out - these files don't exist yet
// import "@/App.css";
// import "@/css/all.css";
// import "@/css/c_forum.css";
// import "@/css/c_forum_2.css";
// import "@/css_own/A_Front_A.css";
// import "@/css_own/style_upload_file.css";
// import "@/css_own/R_Action_reply_C_switch.css";
// import "@/Javascript_Login/register_01.css";
// import "@/Javascript_Login/alert.css";
// import "@/Javascript_Login/style_upload_file.css";
// import "@/Javascript_Login/jquery.Jcrop.min.css";
// import "@/Javascript_Login/register_03.css";
// import "@/css/style.css";
// import "@/Javascript/E_Commentsection.css";
// import "@/Javascript/T_time_keeper_A_Element.css";
// import "@/Javascript/F_function.css";
// import "@/Javascript_question/question.css";
// import "@/Javascript/A_Front_A.css";
// import "@/Javascript_sidebar/sidebar.css";
// import "@/css_1/main_container.css";
// import "@/Javascript_group/group.css";
// import "@/Javascript_main/main.css";
// import "@/Javascript_topbar/topbar.css";
// import "@/css/body.css";

//import engine  from "./Javasc2ript_Login/engine.js";
import Engine from "./Javascript_main/engine.js";
import T_time_keeper from "./Javascript/T_time_keeper.js";
import MainChurchSideBarComponent from "./MainChurchSideBarComponent/MainChurchSideBarComponent";

const Person = () => {
  return (
    <>
      <h1>Name: sai </h1>
      <h2>Last name: doe </h2>
      <h3>wau amazing</h3>
    </>
  );
};

function Loading() {
  return <div>Loading</div>;
}

const App = () => {
  const [myScript8, setMyScript8] = useState(0);
  const [myScript9, setMyScript9] = useState(0);
  const [myScript10, setMyScript10] = useState(0);

  useEffect(() => {
    console.log("check2");
    const load = async () => {
      var myclass;

      // Engine is now a proper React component; render directly in JSX
    };
    async function secondFunction() {
      await load();
    }

    secondFunction();

    //  myScript5.g_starter();
    // myScript5.g_starter();
    // const myInstance = new myScript1();
    //myScript1.engine();
    //myScript5.g_starter;
  }, []);

  return (
    <div className="App">
      <div
        className="main_container mt-5 flex flex-col justify-center gap-4 md:mt-10 md:flex-row"
        id="main_container"
      >
        <div className="md:basis-3/5">
          <Engine />{" "}
        </div>
        <T_time_keeper />{" "}
      </div>

      <div id="cropper_holder"></div>
      <div className="login_holder"></div>
    </div>
  );
};

export default App;
